import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState } from 'react';
import { config } from '@utils/config';

interface TanstackQueryProviderProps {
  children: React.ReactNode;
}

export function TanstackQueryProvider({ children }: TanstackQueryProviderProps) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {config.isDev && <ReactQueryDevtools initialIsOpen={false} position={'bottom-right'} />}
    </QueryClientProvider>
  );
}
